import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

//
import global from 'common'

import { completeEnrollEmployeesTask } from 'core'
import { PerksProductTaskIds } from 'core/application/adminDashboard/adminTasks'
import { PlanPeriodDto, getActivePlanPeriod } from 'core/application/adminDashboard/benefitDetails/benefitPlanPeriods'
import invitePerksEmployees from 'core/application/adminDashboard/managePeople/perks/InviteEmployees'

import { useCommandRequestV2 } from 'common/hooks'
import { ROUTE_PATHS } from 'common/routePaths'

import AdminTasksSteps from '../../common/adminTaskStep'
import InviteEmployeesModal from '../../common/inviteYourEmployeesModal'

const PerksAdminTasks = () => {
  const history = useHistory()
  const { t: translate } = useTranslation()
  const [tasks, ,] = global.hooks.useAdminTasks([])
  const [activePlanPeriod] = global.hooks.useQueryRequest<PlanPeriodDto>(null, () => getActivePlanPeriod())
  const [inviteEmployeesModalVisible, setInviteEmployeesModalVisible] = useState<boolean>()

  const { sendCommand: sendCompleteTaskQuery, isLoading } = useCommandRequestV2(({}) => completeEnrollEmployeesTask())

  const taskCallbackMapper = new Map<number, () => void>()
  taskCallbackMapper.set(PerksProductTaskIds.benefitDesign, () =>
    history.push(`${ROUTE_PATHS.DESIGN_BENEFIT_PATH}/${activePlanPeriod?.id}`),
  )
  taskCallbackMapper.set(PerksProductTaskIds.completeProfile, () =>
    history.push(`${ROUTE_PATHS.MANAGE_PEOPLE}/complete-admin-profile`),
  )
  taskCallbackMapper.set(PerksProductTaskIds.enrollEmployees, async () => {
    const result = await sendCompleteTaskQuery({})
    result.completed && history.push(`${ROUTE_PATHS.MANAGE_PEOPLE}?fromtask=true`)
  })
  taskCallbackMapper.set(PerksProductTaskIds.inviteEmployees, () => setInviteEmployeesModalVisible(true))

  const taskIsLoadingMapper = new Map<number, boolean>()
  taskIsLoadingMapper.set(PerksProductTaskIds.enrollEmployees, isLoading)

  return (
    <>
      {activePlanPeriod && (
        <>
          <InviteEmployeesModal
            visible={inviteEmployeesModalVisible}
            benefitStartDate={activePlanPeriod.startDate}
            onCancel={() => setInviteEmployeesModalVisible(false)}
            infoMessage={translate('admin-dashboard.home.invite-alert.perks-invite-employees-popup-first-sentence')}
            inviteApi={invitePerksEmployees}
            showAllEmployeesAddedCheckBox={true}
            onSendInviteToEmployees={() => {
              window.location.href = ROUTE_PATHS.ADMIN_DASHBOARD_PATH
            }}
            checkboxLabel={translate('admin-dashboard.home.invite-alert.perks-checkbox-label')}
          />
        </>
      )}

      {tasks && (
        <AdminTasksSteps
          tasks={tasks}
          taskIsLoading={(taskId) => taskIsLoadingMapper.get(taskId)}
          onTaskClicked={(taskId) => taskCallbackMapper.get(taskId)()}
        />
      )}
    </>
  )
}

export default PerksAdminTasks
